// GameManager.js
var GameManager = pc.createScript('gameManager');

GameManager.prototype.initialize = function(){

    GameManager.instance = this;

    this.log = new Log("GAME_MANAGER");
    this.isGamePaused = false;
    this.isOfferPlay = false;
    this.isGameFinish = false;
    this.adsSoundMute = true;
    this.placeData = new PlaceData();
    this.eventData = new EventData();

    this.startTime = "";
    this.finishTime = "";

    this.app.on('uiManager:lose',this.gamelose,this);
    this.app.on('uiManager:win',this.gamewin,this);
    this.app.on('game:Ready', this.checkLoadAssets, this);
    this.app.on("SKIPPED", this.test, this);
};

GameManager.prototype.GameStart = function(startExtraTime){
    
    //this.log.info("Oyun Başladı");
    rewardedType = "";
    completeMatchStatus = false;
    matchObjectCounter = 0;
    matchThemAllButtonClick = false;
    this.startTime = new Date();
    this.isGamePaused = false;
    
    //console.log(GameUi.instance);
    GameUi.instance.showHideJokerButton(false);    

    EventsManager.instance.changeEventsWallActive(false);

    if (PlayerManager.instance.userData.newPlayer == true) { GameUi.instance.showHideHomeButton(false); } else { GameUi.instance.showHideHomeButton(true); }

    if (PlayerManager.instance.userData.newPlayer == true && PlayerManager.instance.userData.userScore>0) { PlayerManager.instance.userData.newPlayer = false;}

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal) {
      
        this.app.fire("gameManager:gamePlayMode", gamePlayMode.Normal);
        
        if (PlayerManager.instance.userData.interruption == 1) {
  
            let originalLevelTime = PlayerManager.instance.levelData.time;
    
            matchObjectCounter = PlayerManager.instance.userData.savedMatchedObjectCount;
            roomObjectList = [];
            roomObjectList = PlayerManager.instance.userData.roomAssets;
            
            this.loadInterruptionData();
            
            let differencePassingSeconds = originalLevelTime - PlayerManager.instance.levelData.time;
            this.startTime = new Date(this.startTime - differencePassingSeconds*1000);

            CoverManager.instance.updateMatchStatus(PlayerManager.instance.levelData.minObjectCount, matchObjectCounter, true);
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addProgressionEvent", "Start", "ContinueSingleGame", PlayerManager.instance.levelData.levelName, detectCurrentLevel()[0]);}
            
        }
        else 
        {
            PlayerManager.instance.userData.score = 0;

            //if (PlayerManager.instance.userData.newPlayer == true) { PlayerManager.instance.loadTutorialData();}

            if (playExtraTime == false) {
                this.initializeTimer(0,true);
            }
            else {
                //GameUi.instance.showHideShakeButton(true);
                this.initializeTimer(30,true);
                playExtraTime = false;
            }

            if ((PlayerManager.instance.levelData.levelName == "Donut Shop")) {
                CoverManager.instance.updateMatchStatus(PlayerManager.instance.levelData.minObjectCount, 0, false);
                Tutorial.instance.moveObjectTutorialOnOff(true);
            }
            else {
                CoverManager.instance.updateMatchStatus(PlayerManager.instance.levelData.minObjectCount, matchObjectCounter, true);
            }
            if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addProgressionEvent", "Start", "SingleGame", PlayerManager.instance.levelData.levelName, detectCurrentLevel()[0]);}
            
        }
        SpawnManager.instance.spawninitalize();
    }

    else if(PlayerManager.instance.userData.gameMode == gamePlayMode.Places) {
        
        this.app.fire("gameManager:gamePlayMode", gamePlayMode.Places);

        PlayerManager.instance.userData.score = 0;
        CoverManager.instance.updateMatchStatus(this.placeData.minObjectCount, matchObjectCounter, true);
        this.initializeTimer(0,true);

        SpawnManager.instance.spawninitalize(this.placeData.objectCount);
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addProgressionEvent", "Start", "Places", GameManager.instance.placeData.levelName, detectCurrentLevel()[0]);}
        
    }
    
    this.app.fire('gameManager:updatestatus', gamestatus.Play);  
};

GameManager.prototype.GameWin = function(){ 

    //this.log.info("Game Win");
    this.finishTime = new Date();

    this.app.fire('gameManager:updatestatus',gamestatus.Win);
    
    GameUi.instance.showHideHomeButton(false);
    Timer.instance.StopTimer();
    //console.log("Combo Sayısı: " + ScoreManager.instance.maxComboCounter);
    roomObjectList = [];
    
    this.sendScore();
};

GameManager.prototype.sendScore = function () {
    
    ScoreManager.instance.extraPoints();

    let userGameScore = 0;

    var gameAnalyticsCustomFields = { "PlayTime": GameManager.instance.gamePlayDuration()};

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal) {

        let earnExtraPoints;

        if (PlayerManager.instance.userData.newPlayer == true) {
            
            userGameScore = PlayerManager.instance.userData.score;
            this.UpdateLevel(userGameScore,true);
            isTutorialStageComplete = true;

        }
        else {
            if (completeMatchStatus == true) {
                earnExtraPoints = ScoreManager.instance.extraPoints();
                userGameScore = PlayerManager.instance.userData.score + parseInt(earnExtraPoints);
            }
            else {
                userGameScore = PlayerManager.instance.userData.score;
            }
            this.UpdateLevel(userGameScore,false);
        }

        if (GameAnalyticsSdk.instance.gaStatus) {
            GameAnalytics("addProgressionEvent", "Complete", "SingleGame", PlayerManager.instance.levelData.levelName, detectCurrentLevel()[0], parseInt(userGameScore), gameAnalyticsCustomFields);
            GameAnalytics("addDesignEvent", "GamePlayTime:SingleGame:" + GameManaPlayerManagerger.instance.levelData.levelName, parseFloat(GameManager.instance.gamePlayDuration()));
        }
        clearCacheFunction();
    }
    else if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {

        userGameScore = PlayerManager.instance.userData.score;

        PlayerManager.instance.userData.userScore = parseInt(PlayerManager.instance.userData.userScore) + parseInt(userGameScore);
        PlayerManager.instance.SavePlayerData(); 

        if (GameAnalyticsSdk.instance.gaStatus) {
            GameAnalytics("addProgressionEvent", "Complete", "MiniGame", playingMiniGameName, detectCurrentLevel()[0], parseInt(userGameScore), gameAnalyticsCustomFields);

            if (playingMiniGameName == "Math Game") {
                GameAnalytics("addDesignEvent", "GamePlayTime:MiniGame:" + playingMiniGameName, parseFloat(GameManager.instance.gamePlayDuration()));
            }
            else {
                let miniGameTheme = playingMiniGameName == "Attention Game" ? GameManager.instance.eventData.matchKey.toString().replaceAll(',', '-') : GameManager.instance.eventData.matchKey;
                GameAnalytics("addDesignEvent", "GamePlayTime:MiniGame:" + playingMiniGameName + ":" + miniGameTheme, parseFloat(GameManager.instance.gamePlayDuration()));
            }
        }
    }
};

GameManager.prototype.UpdateLevel = async function(value){

    if (!PlayerManager.instance.userData.placeMode && (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal)) {

        currentLevelName = PlayerManager.instance.levelData.levelTemplate;
        PlayerManager.instance.userData.userScore += value;
        
        if (PlayerManager.instance.userData.level<13){
            PlayerManager.instance.userData.level++;
        }
        else {
            this.isGameFinish = true;
            PlayerManager.instance.userData.level = 1;
        }
        
        this.clearInterruptionData();
        
        if (!PlayerManager.instance.userData.newPlayer){
            PlayerManager.instance.GetUserLevel("updateLevel");
        }
        else {
            PlayerManager.instance.userData.newPlayer = false;
            PlayerManager.instance.GetUserLevel("updateLevel");
        }
        PlayerManager.instance.SavePlayerData();   
    }
};

GameManager.prototype.GameLose = function () {

    //this.log.info("Game Lose");
    this.finishTime = new Date();
    this.app.fire('gameManager:updatestatus', gamestatus.Lose);

    GameUi.instance.showHideHomeButton(false);
    SoundManager.instance.playSound('LoseSound');
    //CoverManager.instance.updateMatchStatus(0, 0, false);
    Timer.instance.StopTimer();
    this.clearInterruptionData();

    if (GameAnalyticsSdk.instance.gaStatus) {

        var gameAnalyticsCustomFields = { "PlayTime": GameManager.instance.gamePlayDuration() };

        if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal) {
            GameAnalytics("addProgressionEvent", "Fail", "SingleGame", PlayerManager.instance.levelData.levelName, detectCurrentLevel()[0], parseInt(PlayerManager.instance.userData.score), gameAnalyticsCustomFields);
            //GameAnalytics("addDesignEvent", "GamePlayTime:SingleGame:" + GameManager.instance.challengeGameProb.SelectedRoom, parseFloat(GameManager.instance.gamePlayDuration()));
        }
        else if (PlayerManager.instance.userData.gameMode == gamePlayMode.Places) {
            GameAnalytics("addProgressionEvent", "Fail", "Places", GameManager.instance.placeData.levelName, detectCurrentLevel()[0], parseInt(PlayerManager.instance.userData.score), gameAnalyticsCustomFields);
            //GameAnalytics("addDesignEvent", "GamePlayTime:Places:" + GameManager.instance.challengeGameProb.SelectedRoom, parseFloat(GameManager.instance.gamePlayDuration()));
        }
        else if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
            GameAnalytics("addProgressionEvent", "Fail", "MiniGame", playingMiniGameName, detectCurrentLevel()[0], 0, gameAnalyticsCustomFields);

            if (playingMiniGameName == "Math Game") {
                GameAnalytics("addDesignEvent", "GamePlayTime:MiniGame:" + playingMiniGameName, parseFloat(GameManager.instance.gamePlayDuration()));
            }
            else {
                let miniGameTheme = playingMiniGameName == "Attention Game" ? GameManager.instance.eventData.matchKey.toString().replaceAll(',', '-') : GameManager.instance.eventData.matchKey;
                GameAnalytics("addDesignEvent", "GamePlayTime:MiniGame:" + playingMiniGameName + ":" + miniGameTheme, parseFloat(GameManager.instance.gamePlayDuration()));
            }
        }
    }
    clearCacheFunction();
};


GameManager.prototype.startMiniGame = function () {

    this.startTime = new Date();
    this.app.fire("gameManager:gamePlayMode", gamePlayMode.MiniGame);
    
    rewardedType = "";
    EventsManager.instance.changeEventsWallActive(true);
    CoverManager.instance.updateMatchStatus(0,0,false);
    PlayerManager.instance.userData.score = 0;

    timeBarTotalTime = this.eventData.time;
    matchObjectCounter = 0;

    if (this.eventData.eventId == 1) {

        let expected = EventsManager.instance.initMathChallange();
        this.eventData.matchKey = expected[0];
        this.eventData.mathChallengeOperationKey = expected[1];
        PlayerManager.instance.userData.score = "50";
        
        playingMiniGameName = "Math Game";
        SpawnManager.instance.spawninitalize(this.eventData.assetTag, this.eventData.objectCount);
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addProgressionEvent", "Start", "MiniGame", "MathGame");}
        
    }
    else if (this.eventData.eventId == 2) {
         PlayerManager.instance.userData.score = "150";
         playingMiniGameName = "Word Game";

        this.eventData.matchKey = EventsManager.instance.initWordChallenge();
        SpawnManager.instance.spawninitalize(this.eventData.assetTag, this.eventData.objectCount);
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addProgressionEvent", "Start", "MiniGame", "WordGame", String(this.eventData.matchKey));}
    }
    else if (this.eventData.eventId == 4) {

         PlayerManager.instance.userData.score = "100";
         EventsManager.instance.initAttentionChallenge();
         playingMiniGameName = "Attention Game";
        const matchKeyParameter = this.eventData.matchKey.toString().replaceAll(',','-');
        //console.log("Sonuç: " + matchKeyParameter);
        SpawnManager.instance.eventAttentionSpawn(this.eventData.matchKey,this.eventData.assetTag,this.eventData.objectCount);
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addProgressionEvent", "Start", "MiniGame", "AttentionGame", matchKeyParameter);}
        
    }

    else if (this.eventData.eventId == 6) {
         PlayerManager.instance.userData.score = "250";
         playingMiniGameName = "Link Game";
         EventsManager.instance.initThemeChallenge();
        SpawnManager.instance.eventMultipleAssetInitialize(this.eventData.matchKey,this.eventData.spawnedArrayList,this.eventData.objectCount);
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addProgressionEvent", "Start", "MiniGame", "LinkGame", String(this.eventData.matchKey));}
    }

    this.initializeTimer(0,true);
};

GameManager.prototype.PauseGame = function () {

    if (this.app.root.children[0].name == "Game") {
        console.log("Game Paused");
        // let inputPanel = this.app.root.findByName("NoInput");
        // inputPanel.enabled = true;
        this.isGamePaused = true;
        SoundManager.instance.pauseSound();
        Touch.instance.Pause();
        Timer.instance.PauseTimer();
        TimeBar.instance.pauseBar();
        this.app.fire('gameManager:updatestatus', gamestatus.Pause);
    }

};

GameManager.prototype.ResumeGame = function() {
    
    if (this.app.root.children[0].name == "Game") {
            console.log("Game Resumed");
            // let inputPanel = this.app.root.findByName("NoInput");
            // inputPanel.enabled = false;
            this.isGamePaused = false;
            GameUi.instance.showHideHomeButton(true);
            Touch.instance.Continue();
            Timer.instance.ContinueTimer();
            TimeBar.instance.continueBar();

            this.app.fire('gameManager:updatestatus', gamestatus.Play);
        //}
        SoundManager.instance.resumeSound();
    }
};

GameManager.prototype.ExtraTime = function (isOfferPlay) {

    Timer.instance.StopTimer();
    TimeBar.instance.resetBar();
     GameUi.instance.showHideHomeButton(true); 
     if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame){
         GameUi.instance.showHideJokerButton(true); 
     }
    //Timer.instance.playStartLevelSound();
    if (isOfferPlay){
        this.initializeTimer(30,false,true);
    }
    else {
        this.initializeTimer(30,false);
    }
    
    this.ResumeGame();
    
};

GameManager.prototype.OfferPlay = function(finishGameOfferPanel){

    this.app.fire('gameManager:updatestatus',gamestatus.OfferPlay);

    if (finishGameOfferPanel) {
        WinAndLoseUi.instance.showPanelBackground(false);
        let offerPanel = this.app.root.findByName("OfferPanel");
        offerPanel.destroy();
        
        if (PlayerManager.instance.userData.gameMode != gamePlayMode.MiniGame) {
            CoverManager.instance.updateMatchStatus(PlayerManager.instance.levelData.minObjectCount, matchObjectCounter, true);
        }
        WinAndLoseUi.instance.showTopBar();
        checkOffer = false;
    }

    //Timer.instance.extraTime();
    this.ExtraTime(true);
    //GameUi.instance.showHideHomeButton(false);    
};

GameManager.prototype.gamePlayDuration = function() {

    let differenceTime = this.finishTime.getTime() - this.startTime.getTime();
    let differenceSeconds = differenceTime / 1000;
    return Math.abs(differenceSeconds);
};

GameManager.prototype.LoadEventData = function(miniGameId, callback) {

    var miniGameData = GameData.instance.getMiniGameData(miniGameId); 

    this.eventData.eventId = miniGameData.miniGameIndex;
    this.eventData.eventName = miniGameData.miniGameName;
    this.eventData.objectCount = miniGameData.objectCount;
    this.eventData.time = miniGameData.time;
    this.eventData.assetName = miniGameData.assetName;
    this.eventData.assetTag = miniGameData.assetTag;
    this.eventData.matchKey = miniGameData.matchKey;
    this.eventData.mathChallengeOperationKey = "";

    prepareMiniGameData(miniGameId,callback);
};

GameManager.prototype.LoadPlaceData = function(level, callback){

    PlayerManager.instance.userData.gameMode = gamePlayMode.Places;
    let userLevel = GameData.instance.getLevelData(level);

    this.placeData.levelID = userLevel.levelID;
    this.placeData.levelName = userLevel.levelName;
    this.placeData.levelItem = userLevel.levelItem;
    this.placeData.objectCount = userLevel.objectCount;
    this.placeData.time = userLevel.time;
    this.placeData.levelTemplate = userLevel.levelTemplate;
    this.placeData.levelRoom = userLevel.levelRoom;
    this.placeData.minObjectCount = userLevel.objectCount;
    
    placesButtonIsClicked = false;
    callback(true);
    
};

GameManager.prototype.loadInterruptionData = function() {

    PlayerManager.instance.levelData = JSON.parse(localStorage.getItem("backupLevelData"));

    if (playExtraTime == false) {
        Timer.instance.timeFormat(PlayerManager.instance.levelData.time);
        Timer.instance.StartTimer(PlayerManager.instance.levelData.time);
        timeBarTotalTime = PlayerManager.instance.levelData.time;
        _remainTime = PlayerManager.instance.levelData.time;
    }
    else {
        Timer.instance.timeFormat(PlayerManager.instance.levelData.time + 30);
        Timer.instance.StartTimer(PlayerManager.instance.levelData.time + 30);
        timeBarTotalTime = PlayerManager.instance.levelData.time + 30;
        _remainTime = PlayerManager.instance.levelData.time + 30;
        playExtraTime = false;
    }
};

GameManager.prototype.clearInterruptionData = function () {
    
    PlayerManager.instance.userData.interruption = 0;
    PlayerManager.instance.userData.roomAssets = [];
    PlayerManager.instance.userData.lastTimeProgressBar = null;
    PlayerManager.instance.userData.savedMatchedObjectCount = null;
};


GameManager.prototype.CheckNewLevel = function (levelRoom) {

    //console.log("Giren Level Data: " + lvlData);
    if (PlayerManager.instance.userData.level <= 13) {
        if (currentLevelName != "LivingRoom" && PlayerManager.instance.levelData.levelTemplate != "HobbyRoom") {
            if (PlayerManager.instance.levelData.levelTemplate != currentLevelName) {
                levelUpStatus = true;
                LevelUpbanner.instance.showUI(levelRoom);
                currentLevelName = PlayerManager.instance.levelData.levelRoom;
            }
            else {
                levelUpStatus = false;
            }
        }
        else {
            levelUpStatus = false;
        }
    }
    else {
        levelUpStatus = false;
    }
};

GameManager.prototype.initializeTimer = function (extraTime, startTimeFireStatus, isOfferPlay) {

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal) {
        if (isOfferPlay) {
            Timer.instance.timeFormat(extraTime);
            Timer.instance.StartTimer(extraTime);
            _remainTime = extraTime;
            timeBarTotalTime = extraTime;
        }
        else {
            Timer.instance.timeFormat(PlayerManager.instance.levelData.time + extraTime);
            Timer.instance.StartTimer(PlayerManager.instance.levelData.time + extraTime);
            _remainTime = PlayerManager.instance.levelData.time + extraTime;
            timeBarTotalTime = PlayerManager.instance.levelData.time + extraTime;
        }
    }
    else if (PlayerManager.instance.userData.gameMode == gamePlayMode.Places) {

        if (isOfferPlay) {
            Timer.instance.timeFormat(extraTime);
            Timer.instance.StartTimer(extraTime);
            timeBarTotalTime = extraTime;
        }
        else {
            Timer.instance.timeFormat(this.placeData.time + extraTime);
            Timer.instance.StartTimer(this.placeData.time + extraTime);
            timeBarTotalTime = this.placeData.time + extraTime;
        }

    }
    else if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
        if (isOfferPlay) {
            Timer.instance.timeFormat(extraTime);
            Timer.instance.StartTimer(extraTime);
            timeBarTotalTime = extraTime;
        }
        else {
            Timer.instance.timeFormat(this.eventData.time + extraTime);
            Timer.instance.StartTimer(this.eventData.time + extraTime);
            timeBarTotalTime = this.eventData.time + extraTime;
        }

    }
    if (startTimeFireStatus) {
        this.app.fire("startTimerEffect");
    }

};


    // loadScene(`GameScene`, { hierarchy: true, settings: true }, () => {
        
    //     // promisify(()=>window.h5games.gameReady())().then((x)=>{
    //     //     console.log("sadassasd");
    //     //     GameManager.instance.GameStart()});
    //     window.h5games.gameReady();
    // });

